import {all, call, put, takeEvery} from "redux-saga/effects";
import {history} from "index";
import {currentAccount, login, logout} from "services/user";
import actions from "./actions";

export function* LOGIN({payload}) {
    const {mobile, otp, requestId} = payload;
    yield put({
        type: "user/SET_STATE",
        payload: {
            loading: true
        }
    });
    const success = yield call(login, mobile, otp, requestId);
    yield put({
        type: "user/LOAD_CURRENT_ACCOUNT"
    });
    if (success) {
        yield history.push("/");
        // notification.success({
        //   message: "Logged In",
        //   description:
        //     "You have successfully logged in to Air UI React Admin Template!"
        // });
    }
}

export function* LOAD_CURRENT_ACCOUNT() {
    yield put({
        type: "user/SET_STATE",
        payload: {
            loading: true
        }
    });
    const response = yield call(currentAccount);
    if (response) {
        const {
            uid: id,
            name,
            email,
            mobile,
            roles,
            facility,
            photoURL: avatar
        } = response;
        yield put({
            type: "user/SET_STATE",
            payload: {
                id,
                name,
                email,
                mobile,
                avatar,
                roles: roles,
                facility: facility,
                authorized: true
            }
        });
    }
    yield put({
        type: "user/SET_STATE",
        payload: {
            loading: false
        }
    });
}

export function* LOGOUT() {
    yield call(logout);
    yield put({
        type: "user/SET_STATE",
        payload: {
            id: "",
            name: "",
            roles: [],
            facility: [],
            email: "",
            mobile: "",
            avatar: "",
            authorized: false,
            loading: false
        }
    });
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.LOGIN, LOGIN),
        takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
        takeEvery(actions.LOGOUT, LOGOUT),
        LOAD_CURRENT_ACCOUNT() // run once on app load to check user auth
    ]);
}
